import firebase from "../../Config/firebase";
import React, {Component} from "react";
import {ListGroup} from "reactstrap";
import Article from "../ArticleList/Article/Article";

const db = firebase.firestore()

class NoticeList extends Component{
    constructor(props) {
        super(props);
        this.state={
            isLoaded:false,
            notices: []
        }
    }


    componentDidMount() {
        this.getMyNotice()
    }

    getMyNotice =() =>{
        db.collection('Article')
            .limit(8)
            .where('isPublish','==',true)
            .orderBy('lastModified', 'desc')
            .get()
            .then(docs=>{
                if(!docs.empty){
                    let allNotice = []
                    docs.forEach(function(doc){
                        const notice = {
                            id:doc.id,
                            ...doc.data()
                        }
                        allNotice.push(notice)
                    })
                    this.setState({
                        notices:allNotice
                    },()=>{
                        this.setState({
                            isLoaded:true})

                    })
                }

            })
    }


    render(){
        return (
            <ListGroup flush>
                {
                    this.state.isLoaded ?
                        this.state.notices.map((notice, index) => {
                            return (
                                <Article
                                    key={index}
                                    data={notice}
                                />
                            )
                        })
                        : ''
                }
            </ListGroup>

        );

    }
}

export default NoticeList